import React from 'react';

export default function TopicSelector({ topics, selectedTopicId, onSelect }) {
  if (!topics || topics.length === 0) {
    return (
      <div className="topic-selector-empty">
        <p>No topics available</p>
      </div>
    );
  }

  return (
    <nav className="topic-selector" aria-label="Topics">
      <h2 className="topic-selector-title">Topics</h2>
      <ul className="topic-list">
        {topics.map((topic) => (
          <li key={topic.id}>
            <button
              type="button"
              className={`topic-item ${selectedTopicId === topic.id ? 'active' : ''}`}
              onClick={() => onSelect(topic.id)}
              title={`${topic.name}${topic.language ? ` (${topic.language})` : ''}: ${topic.description || 'No description'}`}
              aria-current={selectedTopicId === topic.id ? 'page' : undefined}
            >
              <span className="topic-name">
                {topic.name}
                {topic.language && (
                  <span className="topic-language-badge">{topic.language}</span>
                )}
              </span>
              {topic.description && (
                <span className="topic-description-tooltip">
                  {topic.description}
                </span>
              )}
              {topic.lectureCount !== undefined && (
                <span className="topic-count">
                  {topic.lectureCount} lecture{topic.lectureCount !== 1 ? 's' : ''}
                </span>
              )}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
